import Vue from 'vue'
import _ from 'lodash'

window._ = require('lodash')

Vue.use({
  install (Vue) {
    if (Vue.prototype.hasOwnProperty('_')) return

    Object.defineProperty(Vue.prototype, '_', {
      get () {
        return _
      }
    })
  }
})
